import type { IUser } from '../interfaces';

export class User implements IUser {
    id: IUser['id'];
    email: IUser['email'];
    firstName: IUser['firstName'];
    lastName: IUser['lastName'];
    isAdmin: IUser['isAdmin'];
    isSuperUser: IUser['isSuperUser'];
    customers: IUser['customers'];
    welcomeMessageSent?: IUser['welcomeMessageSent'];
    hasKundeportalInteresse: IUser['hasKundeportalInteresse'];
    isAdminUserAllowed: IUser['isAdminUserAllowed'];
    kundenummerList: IUser['kundenummerList'];

    isDrift: IUser['isDrift'];
    isForvalter: IUser['isForvalter'];
    isHandelForvalter: IUser['isHandelForvalter'];
    isKontorForvalter: IUser['isKontorForvalter'];
    isOkonomi: IUser['isOkonomi'];

    constructor(user: IUser) {
        Object.assign(this, user);
    }

    public static empty() {
        return new User({
            id: '',
            email: '',
            firstName: '',
            lastName: '',
            isAdmin: false,
            isSuperUser: false,
            customers: [],
            welcomeMessageSent: undefined,
            hasKundeportalInteresse: false,
            isDrift: false,
            isForvalter: false,
            isHandelForvalter: false,
            isKontorForvalter: false,
            isOkonomi: false,
            isAdminUserAllowed: false,
            kundenummerList: [],
        });
    }
}
